import RepositoriesFactory from "../repositories/RepositoriesFactory";

const localStorageRepo = RepositoriesFactory.get('localStorage'),
    dataRepo = RepositoriesFactory.get('data')

export default {
    install(Vue) {
        Vue.prototype.$handleError = function (err) {
            switch (err.response.status) {
                case 422: {
                    const message = err.response.data.errors[Object.keys(err.response.data.errors)[0]]
                    this.$swal.fire({
                        icon: "error",
                        title: 'Error',
                        text: message
                    })
                    break;
                }

                case 401: {
                    const message = 'Unauthorized'
                    this.$swal.fire({
                        icon: "error",
                        title: 'Error',
                        text: message
                    }).then(() => {
                        const tokenID = localStorageRepo.getTokenId();

                        if (tokenID) {
                            dataRepo.deletePatientToken(tokenID);
                            localStorageRepo.removeTokenId();
                        }

                        localStorageRepo.removeUser();
                        localStorageRepo.removeCountry();
                        this.$router.push({name: 'login'});
                    })
                    break;
                }

                default: {
                    const message = err.response.data.message
                    this.$swal.fire({
                        icon: "error",
                        title: 'Error',
                        text: message
                    })
                }
            }
        }
    }
}
